const cloneDeep = (obj) => JSON.parse(JSON.stringify(obj));

export default cloneDeep;
